"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultGroups = void 0;
var DefaultGroups;
(function (DefaultGroups) {
    DefaultGroups["Supervisors"] = "Supervisors";
    DefaultGroups["Officers"] = "Officers";
    DefaultGroups["Investigative"] = "Investigative Officers";
    DefaultGroups["Booking"] = "Booking Officers";
    DefaultGroups["BookingInvestigative"] = "Booking Investigative Officers";
    DefaultGroups["Importers"] = "Importers";
})(DefaultGroups = exports.DefaultGroups || (exports.DefaultGroups = {}));
//# sourceMappingURL=types.js.map